import React, { createContext } from 'react';
import { OpenVidu, Publisher, Session, Subscriber } from 'openvidu-browser';

/**
 * @typedef {{
 *  session?: Session
 *  publisher?: Publisher
 *  subscribers: Subscriber[]
 *  isConnected: boolean
 *  isLoading: boolean
 *  error?: any
 *  isMobile: boolean
 *  mediaSource: string
 *  joinSession: (sessionId: string) => void
 *  leaveSession: () => void
 *  toggleAudio: () => void
 *  toggleVideo: () => void
 *  switchMediaSource: (newMediaSource: any) => void
 *  clearError: () => void
 * }} OpenViduValue
 * 
 */
/** @type {React.Context<OpenViduValue>} */
export const OpenViduContext = createContext();